import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'user/profile', method: 'GET', body: null, token: token })
}
